import { createFileRoute } from '@tanstack/react-router';
import LaborOutcomePrediction from 'containers/LaborOutcomePrediction';

export const Route = createFileRoute('/_authenticated/laborOutcomePrediction')({
  component: LaborOutcomePrediction,
});
